import { useEffect, useState } from 'react';
import { AiOutlineClose, AiOutlineMenu } from 'react-icons/ai';
import { Link, NavLink } from 'react-router-dom';
import logo from '../images/hero/logo-mark.webp';
import { navLinks, socialLinks } from '../data/site-content';

export default function NavBar() {
  const [navbar, setNavbar] = useState(false);
  const closeMobileNav = () => setNavbar(false);

  // Lock page scroll and allow Escape to close while the mobile menu is open
  useEffect(() => {
    if (!navbar) return undefined;

    const onKeyDown = (event) => {
      if (event.key === 'Escape') setNavbar(false);
    };

    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKeyDown);

    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [navbar]);

  return (
    <nav className='sticky top-0 z-50 w-full border-b border-line bg-ink/75 backdrop-blur-xl'>
      <div className='container-site flex h-20 items-center justify-between gap-6'>
        <Link
          to='/'
          onClick={closeMobileNav}
          className='flex shrink-0 items-center gap-3'
        >
          <img
            src={logo}
            alt='Darkside Tattoos logo'
            className='h-12 w-auto lg:h-14'
          />
          <span className='font-display text-2xl tracking-wider text-bone lg:text-3xl'>
            Darkside Tattoos
          </span>
        </Link>

        <div
          className={`${
            navbar ? 'flex' : 'hidden'
          } absolute inset-x-0 top-full h-[calc(100dvh-5rem)] flex-col justify-between overflow-y-auto border-t border-line bg-ink px-6 py-10 lg:static lg:flex lg:h-auto lg:flex-1 lg:flex-row lg:items-center lg:justify-end lg:gap-10 lg:overflow-visible lg:border-0 lg:bg-transparent lg:p-0`}
        >
          <ul className='flex flex-col gap-5 lg:flex-row lg:items-center lg:gap-8'>
            {navLinks.map(({ name, path }) => (
              <li key={path}>
                <NavLink
                  to={path}
                  end
                  onClick={closeMobileNav}
                  className={({ isActive }) =>
                    `relative inline-block font-display text-5xl tracking-wide transition-colors lg:font-sans lg:text-xs lg:font-medium lg:uppercase lg:tracking-[0.2em] after:absolute after:-bottom-1.5 after:left-0 after:h-px after:bg-gold after:transition-all after:duration-300 ${
                      isActive
                        ? 'text-gold after:w-full'
                        : 'text-bone hover:text-gold after:w-0 hover:after:w-full'
                    }`
                  }
                >
                  {name}
                </NavLink>
              </li>
            ))}
          </ul>

          <div className='flex flex-col gap-6 lg:flex-row lg:items-center lg:gap-5'>
            <ul className='flex items-center gap-2'>
              {socialLinks.map(({ href, icon: Icon, label }) => (
                <li key={label}>
                  <a
                    href={href}
                    target='_blank'
                    rel='noreferrer'
                    aria-label={label}
                    className='flex h-10 w-10 items-center justify-center rounded-full text-muted transition-colors hover:bg-white/5 hover:text-gold'
                  >
                    <Icon size={18} aria-hidden='true' />
                  </a>
                </li>
              ))}
            </ul>
            <Link
              to='/contact'
              onClick={closeMobileNav}
              className='btn-primary w-full py-2.5 lg:w-auto'
            >
              Book Now
            </Link>
          </div>
        </div>

        <button
          type='button'
          className='flex h-11 w-11 items-center justify-center rounded-full border border-line text-bone transition-colors hover:border-gold hover:text-gold lg:hidden'
          aria-label={navbar ? 'Close menu' : 'Open menu'}
          aria-expanded={navbar}
          onClick={() => setNavbar(!navbar)}
        >
          {navbar ? <AiOutlineClose size={20} /> : <AiOutlineMenu size={20} />}
        </button>
      </div>
    </nav>
  );
}
